<template>
  <div>
    <el-dialog
      :title="$t('Ətraflı_məlumat')"
      :visible.sync="showModal"
      width="80%"
      top="5vh"
      append-to-body
      :close-on-press-escape="false" 
      :close-on-click-modal="false" 
    >
      <div>
        <accident-comm-base :value="item" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showModal = false">{{$t('İmtina')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AccidentCommBase from "../components/AccidentCommBase.vue";
export default {
  data() {
    return {
      showModal: false,
      item: {},
    };
  },
  components: {
    AccidentCommBase,
  },
  methods: {
    view(item) {
      this.item = item;
      this.showModal = true;
    },
  },
};
</script>

<style scoped>
</style>
